<template>
  <div class="block-introduction">
    <div class="block-introduction-entry" @click="showPopup">
      <span>{{ entryTitle }}</span>
    </div>
    <van-icon name="question-o" size="15px" color="#838281" @click="showPopup"/>

    <c-popup
      :visible.sync="visible"
      :title="entryTitle"
      :cancelButtonText="popupCancelButtonText"
      imageSrc="@/assets/images/popup-image.png"
    >
      <!-- 使用插槽来渲染自定义内容 -->
      <template #content>
        <slot name="content">
          <!-- 默认内容 -->
          <p>{{ popupContent }}</p>
        </slot>
      </template>
    </c-popup>
  </div>
</template>

<script>

export default {
  name: 'BlockIntroduction',
  props: {
    entryTitle: {
      type: String,
      default: ''
    },
    popupContent: {
      type: String,
      default: ''
    },
    popupCancelButtonText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    showPopup() {
      this.visible = true;
    }
  }
}
</script>

<style lang="less" scoped>
.block-introduction {
  display: flex;
  justify-content: center;
  align-items: center;
  .block-introduction-entry {
    display: inline-block;
    background: linear-gradient(0deg, #F7CB6B 0%, #FBA980 100%);
    border-radius: 8px;
    padding: 10px 20px;
    font-weight: bold;
    text-align: center;
    font-size: 20px;
    color: #FCFCFB;
    line-height: 25px;
  }
}

</style>
